/** Guides 枢纽页：正文不写 inline 内链；每个 URL 在本页仅出现一次（Hero 按钮或卡片） */

export const HUB_ENHANCEMENTS = {
	features: {
		heroIntro:
			'Pick the area below that matches what you want to change on your phone. Menu names move between APK versions—confirm each toggle in your installed build before relying on it.',
		heroActions: [
			{ href: '/features/privacy-features/', label: 'Privacy settings', primary: true },
			{ href: '/features/customization/', label: 'Themes', primary: false },
		],
		sections: [
			{
				h2: 'Pick a feature area',
				lead: 'Each card lists taps to try first. Search settings for the bold keywords if your layout looks different from screenshots on this site.',
				categoryCards: [
					{
						icon: '🔒',
						title: 'Privacy & online status',
						tasks: [
							'Open <strong>GB Settings → Privacy</strong> (or Settings → Privacy)',
							'Toggle online status, blue ticks, or typing indicators one at a time',
							'Test with a trusted contact before using in work groups',
						],
						href: '/features/privacy-features/',
						linkLabel: 'Open privacy guide',
					},
					{
						icon: '🎨',
						title: 'Themes & appearance',
						tasks: [
							'Try <strong>GB Settings → Theme</strong> for packs and fonts',
							'Set chat wallpaper from chat menu → Wallpaper',
							'Screenshot theme name before updating APK',
						],
						href: '/features/customization/',
						linkLabel: 'Open customization guide',
					},
					{
						icon: '💬',
						title: 'Chat tools',
						tasks: [
							'Look for <strong>Scheduler</strong> or auto-reply under GB Settings',
							'Enable chat lock per thread if your build supports it',
							'Keep auto-replies short and label them as automated',
						],
						href: '/features/chat-features/',
						linkLabel: 'Open chat tools guide',
					},
					{
						icon: '📁',
						title: 'Media & status',
						tasks: [
							'Check send limits before large video uploads—use Wi‑Fi',
							'Status save options appear after viewing a status once',
							'Only save status media you have permission to keep',
						],
						href: '/features/media-sharing/',
						linkLabel: 'Open media guide',
					},
				],
			},
			{
				h2: 'Quick reference',
				facts: [
					{ label: 'Where menus live', value: 'GB Settings, Universal, or Privacy—wording changes between v18.x builds' },
					{ label: 'After every update', value: 'Re-open privacy and theme menus; toggles may reset to defaults' },
					{ label: 'Official WhatsApp', value: 'Already includes last seen, read receipts, and Chat Lock on many devices' },
					{ label: 'Account risk', value: 'Extra privacy toggles do not remove enforcement risk from using an unofficial client' },
				],
			},
			{
				h2: 'Step-by-step articles',
				lead: 'Longer walkthroughs with FAQ blocks—open only the topic you need.',
				linkCards: [
					{ icon: '⏱', href: '/schedule-messages-gb-whatsapp/', label: 'Schedule messages', desc: 'Queue sends for later' },
					{ icon: '🔐', href: '/lock-individual-chats-gb-whatsapp/', label: 'Lock chats', desc: 'PIN or biometric gates' },
					{ icon: '✓', href: '/hide-blue-ticks-gb-whatsapp/', label: 'Hide blue ticks', desc: 'Read receipt controls' },
					{ icon: '🔕', href: '/use-gb-whatsapp-dnd-mode/', label: 'DND mode', desc: 'Quiet hours in-app' },
					{ icon: '📥', href: '/download-gb-whatsapp-status-videos/', label: 'Save status videos', desc: 'When your build allows' },
				],
			},
			{
				h2: 'If a toggle is missing',
				callout: {
					type: 'warn',
					text: 'Publishers remove experimental menus without notice. Search settings before assuming the feature was deleted, and avoid installing unknown APK files just to “unlock” one option.',
				},
				list: [
					'Compare the version string in app Settings with the label on our download page',
					'If enabling a theme causes force-close, treat it as a stability issue—not a setting to retry blindly',
					'Sensitive conversations may belong on official WhatsApp even when mod privacy toggles exist',
				],
			},
			{
				h2: 'Safety context',
				linkCards: [
					{ icon: '🛡', href: '/safety/', label: 'Safety hub', desc: 'Risk overview before you rely on a mod daily' },
				],
			},
		],
	},
	installation: {
		heroIntro:
			'Work through backup, file verification, Android permissions, SMS verification, and restore—in that order. Allow 15–30 minutes on Wi‑Fi with the phone charged.',
		heroActions: [
			{ href: '/download/', label: 'APK file details', primary: true },
			{ href: '/installation/backup-chats/', label: 'Back up chats', primary: false },
		],
		sections: [
			{
				h2: 'At a glance',
				facts: [
					{ label: 'APK size', value: '~191.3 MB for v18.80 — a much smaller file usually means an incomplete download' },
					{ label: 'Android', value: '5.0+ (Settings → About phone)' },
					{ label: 'Dual apps', value: 'Some builds sit beside official WhatsApp; others replace it—decide before you register the same number twice' },
					{ label: 'Unofficial APK', value: 'Sideloading is your choice; read fake-APK red flags on the safety section of this site when unsure' },
				],
				callout: {
					type: 'tip',
					text: 'Do not uninstall official WhatsApp until you know whether your GB build is meant to run alongside it or replace it.',
				},
			},
			{
				h2: 'Install flow (do in this order)',
				steps: [
					'On Wi‑Fi, save the APK and confirm the file size in Downloads matches the published figure for v18.80.',
					'Run in-app backup and note the timestamp shown when it finishes.',
					'Tap the APK → allow install from Chrome or Files when Android prompts (per-app permission, not “unknown sources everywhere”).',
					'Wait for Install to complete, open GB WhatsApp Pro, enter your number, and finish SMS or call verification.',
					'On the restore screen, continue only if you expect that backup; stop and troubleshoot before clearing data if chats look wrong.',
					'Send a test message and enable notification categories under Android Settings → Apps.',
				],
			},
			{
				h2: 'Manufacturer tips',
				sectionClass: 'section-content--band',
				lead: 'Permission dialogs differ by brand—these cards point to the matching deep guide.',
				categoryCards: [
					{
						icon: '📱',
						title: 'Samsung / Galaxy',
						tasks: [
							'Settings → Apps → Special access → Install unknown apps → allow Chrome or Files',
							'Wait for Device care scan to finish before tapping Install',
						],
						href: '/installation/android/',
						linkLabel: 'Android install walkthrough',
					},
					{
						icon: '📱',
						title: 'Xiaomi / Redmi',
						tasks: [
							'Prefer opening the APK from Files after granting install permission',
							'After first launch, check autostart and notification settings if alerts are delayed',
						],
						href: '/help/notifications-not-working/',
						linkLabel: 'Notification troubleshooting',
					},
					{
						icon: '📱',
						title: 'Stock Android',
						tasks: [
							'Read the full Play Protect sheet before continuing',
							'If Chrome was blocked, retry from the Files app with permission granted there',
						],
						href: '/help/not-installing/',
						linkLabel: 'When install is blocked',
					},
				],
			},
			{
				h2: 'More installation chapters',
				lead: 'Use one chapter when the overview above is not enough.',
				linkCards: [
					{ icon: '↩', href: '/installation/restore-chats/', label: 'Restore chats', desc: 'After verification' },
					{ icon: '➕', href: '/installation/without-uninstalling/', label: 'Without uninstalling', desc: 'Dual-app scenarios' },
					{ icon: '🛡', href: '/safety/malware-and-fake-apks/', label: 'Fake APK warnings', desc: 'Before you sideload' },
				],
			},
			{
				h2: 'When install fails',
				callout: {
					type: 'warn',
					text: 'Do not clear app storage or uninstall until a backup is verified. Parse errors usually mean delete the APK and download again on Wi‑Fi until the size matches.',
				},
				list: [
					'Parse error → re-download the full ~191.3 MB file',
					'App not installed → free storage and retry before switching mirrors',
					'Managed work phone → IT policy may forbid sideloading entirely',
				],
			},
		],
	},
	update: {
		heroIntro:
			'Manual APK updates need a backup, a version check, and an install-over attempt before you consider uninstalling. Note your current build string before you download anything new.',
		heroActions: [
			{ href: '/update/check-version/', label: 'Check version', primary: true },
			{ href: '/update/without-losing-chats/', label: 'Backup-first update', primary: false },
		],
		sections: [
			{
				h2: 'Update checklist',
				lead: 'Run top to bottom when a new v18.x build is listed on the download page.',
				steps: [
					'Settings → App info: write down the current version string.',
					'Backup chats and wait until the progress bar finishes.',
					'Download the new APK and confirm file size against the published details.',
					'Install over the existing app when Android offers Update.',
					'Re-open GB Settings and screenshot privacy toggles in case the new build reset them.',
					'If install fails, read the update-failed chapter before uninstalling.',
				],
			},
			{
				h2: 'Quick reference',
				facts: [
					{ label: 'Play Store', value: 'Does not update GB WhatsApp Pro—manual APK only' },
					{ label: 'Expired screen', value: 'Usually an old APK block, not the same as an account ban' },
					{ label: 'Signature mismatch', value: 'Different publisher → uninstall may be required after backup' },
					{ label: 'Rollback', value: 'Keep the previous APK file only when signatures still match' },
				],
			},
			{
				h2: 'When to wait',
				callout: {
					type: 'tip',
					text: 'Delay updating if you are traveling, waiting on one SMS code, or your current build is stable before a deadline. Write the working version in your notes app.',
				},
				list: [
					'Avoid chasing every “latest” mirror posted in comment sections',
					'After a major Android OS upgrade, wait for a compatible mod release if crashes start',
				],
			},
			{
				h2: 'Update chapters & articles',
				linkCards: [
					{ icon: '⚠', href: '/update/update-failed/', label: 'Update failed', desc: 'Install-over-old errors' },
					{ icon: '📰', href: '/gb-whatsapp-expired-version/', label: 'Expired version message', desc: 'Blog + FAQ' },
					{ icon: '📰', href: '/gb-whatsapp-not-working-after-update/', label: 'After update issues', desc: 'Crash or login loops' },
					{ icon: '📰', href: '/gb-whatsapp-android-compatibility/', label: 'Android compatibility', desc: 'OS vs APK' },
					{ icon: '📥', href: '/download/', label: 'Download page', desc: 'Current v18.80 file' },
				],
			},
		],
	},
	safety: {
		heroIntro:
			'No modified WhatsApp build is officially supported, and none can be guaranteed safe or ban-free. The sections below explain what changes when you sideload GB WhatsApp Pro, how to spot bad APKs, and what to do if WhatsApp flags your number—so you can decide with realistic expectations, not ad copy.',
		heroActions: [
			{ href: '/safety/malware-and-fake-apks/', label: 'Fake APK red flags', primary: true },
			{ href: '/safety/account-ban-risk/', label: 'Account ban risk', primary: false },
		],
		sections: [
			{
				h2: 'Unofficial software by definition',
				paragraphs: [
					'GB WhatsApp Pro is distributed as an APK outside Google Play. You are trusting whoever signed and published that file—not Meta’s store review, update pipeline, or support desk. When something breaks, you cannot call WhatsApp LLC and expect them to troubleshoot a mod menu.',
					'Modified clients can add privacy toggles, themes, and media options, but they also change how the app talks to WhatsApp servers. That mismatch is why enforcement messages, delayed updates, and “use official WhatsApp” banners appear for some numbers while others report months of daily use.',
					'Sideloading is a deliberate choice: Android will show Play Protect or manufacturer warnings because unknown APKs can carry altered code. Continuing after reading those warnings means you accept that risk—not that Google has vetted GB WhatsApp Pro as safe.',
					'GBWhatPro.org publishes independent guides. We do not develop the APK, host WhatsApp accounts, or reset bans. Use this page to calibrate risk before install and to know where to read next—not as a promise that any mod is “100% secure.”',
				],
			},
			{
				h2: 'Account restriction risk',
				paragraphs: [
					'WhatsApp’s terms treat unofficial clients as unsupported. Accounts may see temporary limits, verification loops, or messages asking you to switch to the official app. Frequency and timing vary; comparing your experience to a friend’s build is unreliable because enforcement is not public and can change without notice.',
					'Marketing labels such as “anti-ban” or “ban proof” describe feature branding inside some mods, not a contract with Meta. Paying strangers for “unban APKs” or pasting patch files from comment sections usually adds malware risk without fixing policy blocks.',
					'If your number is tied to banking alerts, two-factor codes, or customer-facing work, a restriction can lock you out of more than chat. Keep a working official WhatsApp backup path—or another verified channel—for those conversations even if you experiment with GB WhatsApp Pro on a secondary number first.',
				],
				linkCards: [
					{ href: '/safety/account-ban-risk/', label: 'Account ban risk', desc: 'Signals, myths, and safer habits' },
				],
			},
			{
				h2: 'APK source integrity',
				paragraphs: [
					'Fake or repackaged APKs often reuse familiar names with wrong file sizes, extra permissions, or code that never appeared in the publisher’s original build. A download that finishes in seconds when you expect ~191 MB, or an installer from a random Telegram channel, is a stop signal—not a bargain.',
					'Compare size, download time, and the app that opened the file (browser vs Files). Keep one known-good copy labeled with date and version before you try mirrors. If behavior after install feels wrong—unexpected SMS permissions, aggressive ads, or login screens you do not recognize—uninstall and treat the file as untrusted even if an online scanner returned “clean” once.',
					'Privacy toggles inside a mod do not remove server-side visibility or legal obligations. They change what contacts see on-device, not whether WhatsApp can apply account policies. Read privacy-specific notes when you care about read receipts, backups, or cloud sync—not only about hiding online status.',
				],
				linkCards: [
					{ href: '/safety/malware-and-fake-apks/', label: 'Malware & fake APKs', desc: 'Red flags before you tap Install' },
					{ href: '/safety/privacy-risks/', label: 'Privacy risks', desc: 'What mods can and cannot hide' },
				],
			},
			{
				h2: 'When official WhatsApp is the better fit',
				paragraphs: [
					'Choose the Play Store app when you need automatic security updates, Meta support, WhatsApp Business verification, or company policies that forbid sideloading. Those requirements conflict with manual APK maintenance by design.',
					'GB WhatsApp Pro information on this site is for people who already accept mod-specific trade-offs: manual updates, unofficial support, and the possibility that a future login will show a restriction banner. If that sounds stressful for your main number, official WhatsApp remains the lower-friction option.',
					'You can still read safety material before deciding—understanding fake APK signs and ban context helps even if you never install a mod, because scam download pages target search traffic for “GB WhatsApp” regardless of intent.',
				],
			},
			{
				h2: 'If you already saw a warning or ban message',
				paragraphs: [
					'Screenshot the exact text, note any countdown timer, and write whether chats still send or only fail for new messages. Stop requesting SMS codes in rapid loops; carriers and WhatsApp may throttle repeats and make recovery harder.',
					'While the mod still opens, run an in-app backup and export anything critical (media folders, starred messages) to storage you control. Uninstalling in panic—or installing a second “anti-ban” APK on top—often loses local data when no backup exists.',
					'Temporary limits sometimes lift after the timer expires if you follow on-screen instructions. Permanent-style blocks may require official WhatsApp and a supported restore path; mod backups do not always import into the store app. Plan time on Wi‑Fi before you wipe the mod.',
					'GBWhatPro.org cannot lift restrictions on your number or appeal on your behalf. Use our material to protect data and understand context; account recovery flows go through official WhatsApp when they are offered.',
				],
				linkCards: [
					{ href: '/why-is-gb-whatsapp-account-banned/', label: 'Why accounts get restricted', desc: 'Temporary vs permanent signals' },
					{ href: '/switch-from-gb-whatsapp-to-official-whatsapp/', label: 'Switch to official WhatsApp', desc: 'Backup limits explained' },
				],
			},
			{
				h2: 'Pre-install risk checklist',
				lead: 'Walk through this on the same phone that will install the APK—about five minutes on Wi‑Fi before you tap Install.',
				list: [
					'You downloaded the APK from a source you can compare with published file size and version details',
					'You understand WhatsApp may restrict accounts that use unofficial clients',
					'You backed up chats and know whether your build uses local, cloud, or mod-specific backup paths',
					'You are not installing solely because of “anti-ban” or “100% safe” marketing language',
					'Sensitive work, health, or 2FA conversations have a fallback on official WhatsApp if this number gets limited',
					'You read Play Protect or OEM warnings in full and accept sideloading anyway',
				],
				callout: {
					type: 'warn',
					text: 'If any line above is “no,” pause the install. Fetch the published file, finish backup, or stay on official WhatsApp until you can answer yes without guessing.',
				},
			},
			{
				h2: 'Longer reads on safety',
				lead: 'These articles go deeper on one topic each—open only the angle that matches your situation.',
				linkCards: [
					{ href: '/is-gb-whatsapp-safe/', label: 'Is GB WhatsApp safe?', desc: '2026 risk overview' },
					{ href: '/will-gb-whatsapp-get-you-banned/', label: 'Ban risk explained', desc: 'Policy context' },
					{ href: '/does-gb-whatsapp-anti-ban-work/', label: 'Anti-ban claims', desc: 'What mods cannot promise' },
					{ href: '/gb-whatsapp-says-use-official-whatsapp/', label: 'Official app warning', desc: 'When WhatsApp blocks mods' },
				],
			},
		],
	},
	help: {
		heroIntro:
			'Match your symptom to one guide below. Each article lists checks in order—have your Android version and GB build string ready.',
		heroActions: [
			{ href: '/faq/', label: 'Short FAQ', primary: true },
			{ href: '/blog/', label: 'Longer articles', primary: false },
		],
		sections: [
			{
				h2: 'Install & setup',
				lead: 'APK never installed, verification stuck, or app closes on launch.',
				linkCards: [
					{ icon: '🚫', href: '/help/not-installing/', label: 'Not installing', desc: 'Parse errors, Play Protect' },
					{ icon: '📵', href: '/help/verification-code-not-received/', label: 'No SMS code', desc: 'SIM, roaming, throttling' },
					{ icon: '🚪', href: '/help/not-opening/', label: 'Not opening', desc: 'Splash hang or instant close' },
				],
			},
			{
				h2: 'App stability',
				linkCards: [
					{ icon: '💥', href: '/help/keeps-crashing/', label: 'Keeps crashing', desc: 'Storage, WebView, bad update' },
					{ icon: '💾', href: '/help/storage-problems/', label: 'Storage full', desc: 'Free space, cache order' },
				],
			},
			{
				h2: 'Messages & notifications',
				linkCards: [
					{ icon: '➡', href: '/help/messages-not-sending/', label: 'Not sending', desc: 'One grey tick stuck' },
					{ icon: '⬅', href: '/help/messages-not-receiving/', label: 'Not receiving', desc: 'Background limits' },
					{ icon: '🔔', href: '/help/notifications-not-working/', label: 'Notifications off', desc: 'Channels, autostart' },
					{ icon: '🖼', href: '/help/photos-videos-not-downloading/', label: 'Media not downloading', desc: 'Wi‑Fi, permissions' },
				],
			},
			{
				h2: 'Suggested order (no extra links)',
				sectionClass: 'section-content--band',
				list: [
					'<strong>New install failed</strong> — use Not installing, then the Android install chapter if permission screens confuse you',
					'<strong>Crashes after update</strong> — use Keeps crashing, then Update failed if the problem started right after an APK swap',
					'<strong>Account warning banner</strong> — screenshot, back up while the app opens, then read ban-risk material before installing another mod',
					'<strong>Backup failed</strong> — free storage first, then the backup chapter, then the backup troubleshooting article',
				],
			},
			{
				h2: 'Before you email us',
				callout: {
					type: 'tip',
					text: 'Write down Android version, GB version, exact error text, and whether the issue started after an APK or OS update. We publish guides only—we cannot reset bans or send SMS codes.',
				},
			},
			{
				h2: 'Long-form troubleshooting',
				linkCards: [
					{ icon: '📰', href: '/gb-whatsapp-verification-code-not-received/', label: 'Verification code', desc: 'Dual-SIM checks' },
					{ icon: '📰', href: '/gb-whatsapp-keeps-crashing/', label: 'Keeps crashing (blog)', desc: 'Extended walkthrough' },
					{ icon: '📰', href: '/gb-whatsapp-messages-not-sending/', label: 'Messages pending', desc: 'Network and VPN' },
					{ icon: '📰', href: '/gb-whatsapp-backup-not-working/', label: 'Backup not working', desc: 'Local vs cloud' },
					{ icon: '🛡', href: '/safety/account-ban-risk/', label: 'Account ban risk', desc: 'Policy context' },
					{ icon: '✉', href: '/contact/', label: 'Contact', desc: 'Site corrections only' },
				],
			},
		],
	},
}
